import { displayShortDate } from '../../utils/Format/Format';
import { TRANSPARENCY_TYPES } from '../../utils/constants';
import { sortByTitle } from '../../utils/manager-utils';

export const investmentObjectiveCardBottomUtil = (iClass) => (gqlResult) => {
    if (!gqlResult) return null;

    const { cusip, inceptionDate, inavTicker, taxID, transparencyTypeName } =
        gqlResult.exchangeTradedFund || gqlResult.mutualFund;

    const isTransparent = gqlResult.exchangeTradedFund
        ? transparencyTypeName === TRANSPARENCY_TYPES.FULL
        : false;

    const taxIDiNAVData = gqlResult.exchangeTradedFund
        ? { label: 'iNAV', value: inavTicker }
        : { label: 'TAX ID', value: taxID };

    const returnData = [
        {
            label: `${iClass ? 'I CLASS INCEPTION DATE' : 'INCEPTION DATE'}`,
            value: displayShortDate(inceptionDate)
        },
        { label: 'CUSIP', value: cusip }
    ];

    return isTransparent
        ? [returnData]
        : [
              [
                  ...returnData,
                  { label: taxIDiNAVData.label, value: taxIDiNAVData.value }
              ]
          ];
};

export const investmentManagersDataUtil = (gqlResult) => {
    if (!gqlResult) return null;

    const { mutualFundManagers } =
        gqlResult.exchangeTradedFund || gqlResult.mutualFund;

    return {
        fundManagers: sortByTitle(mutualFundManagers)
    };
};
